import React, { Component } from 'react';
import "../../styles/home/home.scss";

class CardBox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount(){
       
    }
    
    render() {
       const {name,icon,response,progressValue,progressResponse,tone,breakdown} = this.props;
       const safeProgress = Math.max(0, Math.min(100, parseInt(progressValue) || 0));
       const accent = this.props.textColor || "#244b8f";
       const hasBreakdown = breakdown && breakdown.length > 0;
       const heroClass = hasBreakdown ? " kpi-hero" : "";
       const breakdownContent = hasBreakdown ? (
            <div className="kpi-breakdown">
                {breakdown.map((item) => (
                    <div className="kpi-breakdown-row" key={item.label}>
                        <span style={{ backgroundColor: item.color }}></span>
                        <p>{item.label}</p>
                        <strong>{item.value}</strong>
                    </div>
                ))}
            </div>
       ) : null;
        return (
             <div className="card-box ">
                <div className={`card-container outColor kpi-tile kpi-tone-${tone || "default"}${heroClass}`}>
                    <div className="kpi-tile-top">
                        <div>
                            <p className="kpi-label">{response}</p>
                            <h1 style={{color: accent}}>{name}</h1>
                        </div>
                        {breakdownContent}
                        <div className="kpi-ring" style={{
                            background: `conic-gradient(${accent} ${safeProgress * 3.6}deg, #e7edf4 0deg)`
                        }}>
                            <div className="kpi-ring-inner">
                                <i className={icon}></i>
                            </div>
                        </div>
                    </div>
                    <div className="kpi-tile-bottom">
                        <div className="kpi-meta">{progressResponse}</div>
                        <strong>{safeProgress}%</strong>
                    </div>
                </div>
            </div>
             
            
            
        );
    }
    
}

export default CardBox;
